import React, { useState } from 'react';
import useCatalogues from '../../api/cataloguesGetAddLightBox';
import './Model.css';
import { cloudImg } from '../../general';

const AddToLightBox = ({ id, setShow }) => {
  const catalogues = useCatalogues(id, setShow);
  return (
    <div className="modelpage_model_box_lightbox_add">
      <div className="modelpage_model_box_lightbox_add_boxes">
        <p><b>Add to lightbox</b></p>
        <br />
        {catalogues}
        <br />
        <p style={{ cursor: 'pointer' }} onClick={() => setShow(false)}>Close</p>
      </div>
    </div>
  );
};

export default ({ image, id, viewSize }) => {
  const { high, thumb } = image;
  const [show, setShow] = useState(false);
  return Object.keys(thumb).length !== 0 && (
    <>
      {show && <AddToLightBox id={id} setShow={setShow} />}
      <div className="modelpage_model">
        <div className="modelpage_model_box">
          <p onClick={() => setShow(true)} className="modelpage_model_box_lightbox">add to lightbox</p>
          <a href={cloudImg(high)} target="_blank" rel="noreferrer">
            <p className="modelpage_model_box_high_res">high res</p>
          </a>
        </div>
        <img className="modelpage_model_img" src={cloudImg(thumb[`crop_${viewSize > 2 ? 3 : viewSize}`])} alt={cloudImg(thumb.crop_3)} />
      </div>
    </>
  );
};
